import { SecuredPaymentClient } from 'Core/Api/Payment/SecuredPaymentClient';
import {
  BeginBillPaymentRequest,
  ConfirmCreditCardRegistrationRequestBody,
  AddressDto,
  ReferenceValueDto,
  IReferenceValueDto,
  IBeginBillPaymentRequest,
  IBeginRegisterCreditCardRequest,
  BeginRegisterCreditCardRequest,
} from 'Core/Api/Payment/Api';
import TokenUtility from 'Core/TokenUtility';
import ConfigUtility from 'Core/ConfigUtility';
import Utility from 'Core/Utility';

export class CreditCardRegistrationFormHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  //REGISTER A CARD CARD
  async RegisterCreditCard(request: IBeginRegisterCreditCardRequest) {
    let client = new SecuredPaymentClient();
    client.showLoading = true;
    client.handleGeneralError = false;

    var config = await ConfigUtility.get();
    var authorization = TokenUtility.GetUMAToken();

    var beginBillPaymentRequest = new BeginRegisterCreditCardRequest(request);
    return client
      .beginRegisterCreditCard('Bearer ' + authorization, beginBillPaymentRequest)
      .catch(x => Utility.formatError(x, "Failed to register card."));
  }

  //CONFIRM CREDIT CARD
  ConfirmCreditCard(id: number, body: ConfirmCreditCardRegistrationRequestBody) {
    let client = new SecuredPaymentClient();
    client.showLoading = true;
    const authorization = 'Bearer ' + TokenUtility.GetUMAToken();

    return client
      .confirmCreditCardRegistration(id, authorization, body)
      .catch(x => Utility.formatError(x));
  }

  //GET LISTED CREDIT CARD(S) BY USER ID
  GetRegisteredCreditCard(userId: string) {
    let client = new SecuredPaymentClient();
    client.showLoading = true;
    const authorization = 'Bearer ' + TokenUtility.GetUMAToken();

    return client.getCreditCardRegistrations(userId, authorization).catch((reason: any) => {
      if (reason.response?.status >= 400 && reason.response?.status < 500) {
        throw Error(reason.errorMessage);
      } else {
        throw Error('Error while retriving card information.');
      }
    });
  }

  //DELETE/REMOVE CREDIT CARD
  DeleteCreditCard(id: number) {
    let client = new SecuredPaymentClient();
    client.showLoading = true;
    const authorization = 'Bearer ' + TokenUtility.GetUMAToken();

    return client.deleteCreditCardRegistration(id, authorization).catch((reason: any) => {
      if (reason.response.status >= 400 && reason.response.status < 500) {
        throw Error(reason.errorMessage);
      } else {
        throw Error('Error while trying to delete card.');
      }
    });
  }

  //UPDATE CREDIT CARD BILLING ADDRESS
  UpdateCreditCard(id: number, address: AddressDto) {
    let client = new SecuredPaymentClient();
    client.showLoading = true;
    const authorization = 'Bearer ' + TokenUtility.GetUMAToken();
    return client
      .updateCreditCardBillingAddress(id, authorization, address)
      .catch((reason: any) => {
        if (reason.response.status >= 400 && reason.response.status < 500) {
          throw Error(reason.errorMessage);
        } else {
          throw Error('Error while trying to register card.');
        }
      });
  }

  //GET LIST OF APPROVED CARD TYPES
  async GetCreditCardTypes(): Promise<Array<IReferenceValueDto>> {
    let client = new SecuredPaymentClient();
    client.showLoading = true;
    var cardType: IReferenceValueDto;
    client.handleGeneralError = false;

    var config = await ConfigUtility.get();
    var authorization = TokenUtility.GetUMAToken();

    return client.creditcardTypes('Bearer ' + authorization);
  }

  //GET LIST OF APPROVED CARD CURRENCIES - called by web hook 3d secure
  async GetCreditCardCurrency(): Promise<Array<IReferenceValueDto>> {
    const client = new SecuredPaymentClient();
    client.showLoading = true;
    var cardCurrency: IReferenceValueDto;
    client.handleGeneralError = false;

    var config = await ConfigUtility.get();
    var authorization = TokenUtility.GetUMAToken();

    return client.creditcardCurrencies('Bearer ' + authorization);
  }
}
